import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Paper, styled } from '@mui/material';
import { useFontSizeSetting } from '../../hooks/useChatbotSettings';
const Message = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'fontSize',
})(({ theme, fontSize }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(3),
    width: 'fit-content',
    maxWidth: '80%',
    wordWrap: 'break-word',
    boxShadow: 'none',
    borderRadius: 20,
    fontSize,
    lineHeight: '125%',
    letterSpacing: '0.15px',
    // Override default global styles on consumer sites for child elements
    'p, li': {
        fontSize,
    },
}));
export const BaseMessage = (props) => {
    const { fontSize } = useFontSizeSetting();
    const { children } = props;
    return (_jsx(Message, { fontSize: fontSize, ...props, children: children }));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZU1lc3NhZ2UuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jb21tb24vQmFzZU1lc3NhZ2UudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUU5QyxPQUFPLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxnQ0FBZ0MsQ0FBQztBQUVwRSxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxFQUFFO0lBQzVCLGlCQUFpQixFQUFFLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLEtBQUssVUFBVTtDQUNqRCxDQUFDLENBQXVCLENBQUMsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDakQsR0FBRyxLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUs7SUFDekIsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0lBQ3pCLEtBQUssRUFBRSxhQUFhO0lBQ3BCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsUUFBUSxFQUFFLFlBQVk7SUFDdEIsU0FBUyxFQUFFLE1BQU07SUFDakIsWUFBWSxFQUFFLEVBQUU7SUFDaEIsUUFBUTtJQUNSLFVBQVUsRUFBRSxNQUFNO0lBQ2xCLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLHNFQUFzRTtJQUN0RSxPQUFPLEVBQUU7UUFDUCxRQUFRO0tBQ1Q7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVKLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBRyxDQUFDLEtBQW9DLEVBQUUsRUFBRTtJQUNsRSxNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsa0JBQWtCLEVBQUUsQ0FBQztJQUMxQyxNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsS0FBSyxDQUFDO0lBQzNCLE9BQU8sQ0FDTCxLQUFDLE9BQU8sSUFBQyxRQUFRLEVBQUUsUUFBUSxLQUFNLEtBQUssWUFDbkMsUUFBUSxHQUNELENBQ1gsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9